module.exports = __webpack_public_path__ + "img/1.f27a8427.jpg";